// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3MN55","messages":"Chat_messages__2uhFc","dateDivider":"Chat_dateDivider__1HpKF"};